import SelectedInvoiceState from "@GeriMed/Store/Data/InvoiceHistory/SelectedInvoiceState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

const initialState: SelectedInvoiceState = { selected : [] };

const selectedInvoiceImmerReducer = createTypedReducerWithImmer(initialState, {
    "InvoiceHistory/Selected/Reset": (draft: Draft<SelectedInvoiceState>) => {
        return initialState;
    },
    "InvoiceHistory/Selected/Set": (draft: Draft<SelectedInvoiceState>, action: { selected : { id: string; currentBalance: number;invoiceDate:string; customerPo:string; }[]}) => {
        draft.selected = action.selected;
        return draft;
    },
});

(reducers as any).selectedInvoice = selectedInvoiceImmerReducer;

type SelectedInvoiceReducers = {
    selectedInvoice: typeof selectedInvoiceImmerReducer;
};

export type AddToCartPopupActions = Parameters<SelectedInvoiceReducers[keyof SelectedInvoiceReducers]>[1] | AnyAction;
